// Used to create Dropdown component
class ActionItem {
  constructor(label, onClick) {
    this.label = label;
    this.onClick = onClick;
  }
}

export default ActionItem;
